<template>
	<div class="ExplanationBox">
		<div class="sidebar-callout">
			<div v-if="displayText.length < characterField || fullBox==true">
				<p class="p2 expl" v-html="displayText"></p>
			</div>
			<div v-else-if="!showMoreActive">
				<p class="p2 expl"><span v-html="displayText.slice(0, characterField) + '...'"></span><a class="see-more-link" @click="showMoreActive = true" @keyup.enter="showMoreActive = true" tabindex="0">&#32;See more</a></p>
			</div>
			<div v-else-if="showMoreActive">
				<p class="p2 expl"><span v-html="displayText"></span><a class="see-more-link" @click="showMoreActive = false" @keyup.enter="showMoreActive = false" tabindex="0">&#32;See less</a></p>
			</div>
			<p v-if="color === 'green'" class="green-expl"><v-icon color="#4CAF50" small>lock_open</v-icon>This can be changed later</p>
			<p v-else-if="color === 'red'" class="red-expl"><v-icon color="#FB5051" small>lock</v-icon>Cannot be changed after study is created</p>
			<p v-else-if="color === 'yellow'" class="yellow-expl"><v-icon color="#f6800a" small>warning</v-icon>Can be changed until respondent accounts are created</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExplanationBox',
	props: {
		color: String,
		displayText: String,
		fullBox: Boolean
	},
	data: () => ({
		showMoreActive: false,
		characterField: 178
	}),
	mounted () {
	}
}
</script>

<style>
</style>
